import axios from "axios";
import { SLS_URL } from "../../Config/slsConfig";

const axiosSecure = (accessToken: string | undefined) => {
  if (!accessToken) throw new Error("No access token provided");
  return axios.create({
    baseURL: SLS_URL,
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
};

export default axiosSecure;
